import { render, staticRenderFns } from "./foodora_export.vue?vue&type=template&id=2e6a07c4&scoped=true&"
import script from "./foodora_export.vue?vue&type=script&lang=js&"
export * from "./foodora_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a07c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6a07c4')) {
      api.createRecord('2e6a07c4', component.options)
    } else {
      api.reload('2e6a07c4', component.options)
    }
    module.hot.accept("./foodora_export.vue?vue&type=template&id=2e6a07c4&scoped=true&", function () {
      api.rerender('2e6a07c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/foodora/foodora_export.vue"
export default component.exports